import QrLandingPage from './QrLandingPage';

export default QrLandingPage;
